import { useState, useEffect } from 'react';
//
import { useSelector } from 'redux/store';
import LoadingScreen from './LoadingScreen';

// ----------------------------------------------------------------------


export default function LoaderCallApi() {
  const [counter, setCounter] = useState(0);

  const { isLoading: isLoadingUser } = useSelector((state) => state.user);
  const { isLoading: isLoadingActor } = useSelector((state) => state.actor);
  const { isLoading: isLoadingMessage } = useSelector((state) => state.message);

  const { isLoading: isLoadingProfile } = useSelector((state) => state.profile);
  const { isLoading: isLoadingPatient } = useSelector((state) => state.patient);
  const { isLoading: isLoadingAll } = useSelector((state) => state.all);
  const { isLoading: isLoadingHistories } = useSelector((state) => state.consultationHistory);
  const { isLoading: isLoadingExams } = useSelector((state) => state.exam);

  const loading = isLoadingUser
    || isLoadingActor
    || isLoadingProfile
    || isLoadingPatient
    || isLoadingMessage
    || isLoadingAll
    || isLoadingHistories
    || isLoadingExams;

  useEffect(() => {
    if (loading)
      setTimeout(() => setCounter(counter + 1), 0);
    else setCounter(0);
  }, [counter, loading]);

  return (
    <>

      {counter > 0 && (
        <LoadingScreen />
      )}
    </>
  );
}
